import { render, staticRenderFns } from "./DeviceResident.vue?vue&type=template&id=7fa70380&"
import script from "./DeviceResident.vue?vue&type=script&lang=js&"
export * from "./DeviceResident.vue?vue&type=script&lang=js&"
import style0 from "./DeviceResident.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports